var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Head'),_c('router-view',{ref:"routerViewRef"}),_c('Foot',{on:{"scrollToPageEl":_vm.scrollToPageEl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }